const en =
{
  "ok": "OK",
  "cancel": "Cancel",
  "delete": "Delete",
  "add_points_button": "Update",
  "add_person": "Add kid",
  "send_message": "Send Message",
  "delete_line": "delete account!",
  "add_person_title": "Add kid name",
  "add_points": "\\u00B1 points",
  "add_note": "Add notes:",
  "history_point_add": "Point add:",
  "history_point_request": "Point requested:",
  "history_point_before": "Point before:",
  "history_note": "Note:",
  "focus_show_history": "Show history.",
  "loading": "Loading…",
  "google_title_text": "Sign in with Google account",
  "sign_out": "Sign Out",
  "signed_out": "Status: Signed Out",
  "disconnect": "Disconnect",
  "share_score": "Share account",
  "share_type": "Share type",
  "note_hint": "Type a note",
  "notificaton_title": "Points updated",
  "notification_content": "Check update",
  "read_only": "With Kid( Read only)",
  "read_and_write": "With spouse( Read and Write)",
  "delete_score": "Delete account",
  "channel_name": "account Updates",
  "channel_description": "Updates about account changes",
  "score_change_notification_title": "account update",
  "score_shared_with_you": "Shared with you:",
  "remove_ads": "Remove Ads",
  "remove_ads_title": "Remove Ads",
  "purchase": "Purchase",
  "please_wait": "Please wait",
  "product_purchased": "Product purchased",
  "product_not_purchased": "Product not purchased",
  "shared_description": "shared",
  "changed_by": "Changed by:",
  "sign_in_cancelled": "sign in cancelled",
  "no_internet_connection": "no internet connection",
  "unknown_error": "unknown error",
  "log_off": "Log off",
  "named_login_button": "Login to secure data",
  "approve_log_off": "Confirm Log Off.",
  "log_in": "Login",
  "recycle_bin": "Recycle bin",
  "recycle_title": "Recycle Bin",
  "clear_recycle_bin": "Clear Recycle Bin",
  "invite_text": "Invite to share account. Click:",
  "invite_mail_title": "Invite from Points-O-Rama",
  "chooser_title": "Please share",
  "history_header": "Account History:",
  "rename_account": "Rename",
  "start_handling_link": "Starting to handle invite. Please wait.",
  "link_handling_fail": "Invite failed. Probably already used!",
  "camera_button_text": "כפתור צילום",
  "history_image_large": "History image",
  "request_button": "Request",
  "move_to_recyclebin_notice": "moving account to recycle bin.",
  "rate_this_app": "Rate and review"
}

export default en;


// WEBPACK FOOTER //
// ./src/i18n/translations/en.js